import { Handle, Position, useReactFlow, type Edge } from '@xyflow/react';
import { BaseNode } from '@/components/base-node';
import { useTranslation } from 'react-i18next';

type EndNodeProps = {
  id: string;
  data: { goodbyeMessage?: string };
};

const EndNode = ({ id, data }: EndNodeProps) => {
  const { t } = useTranslation();
  const { setNodes, setEdges } = useReactFlow();
  const message = data?.goodbyeMessage ?? '';

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNodes((nodes) =>
      nodes.map((n) => (n.id === id ? { ...n, data: { ...n.data, goodbyeMessage: e.target.value } } : n)),
    );
  };

  return (
    <BaseNode>
      <Handle type="target" position={Position.Top} />
      <div className="p-4">
        <p className="font-bold">{t('endOfConversation')}</p>
        <textarea
          rows={3}
          value={message}
          onChange={onChange}
          className="w-full rounded-md border border-gray-300 p-2"
          placeholder={t('goodbyeMessageOptional')}
        />
        <div className="mt-2">
          <button
            onClick={() => {
              setEdges((eds: Edge[]) => eds.filter((e) => e.source !== id && e.target !== id));
              setNodes((nodes) => nodes.filter((n) => n.id !== id));
            }}
            className="text-red-600 px-2 py-1 text-sm border border-red-300 rounded"
          >
            {t('deleteNode')}
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-2">{t('nodeEndsFlow')}</p>
      </div>
    </BaseNode>
  );
};

export default EndNode;
